// extracted by mini-css-extract-plugin
export default {"cont":"MeetingStairs_cont__rRzEU","logo":"MeetingStairs_logo__Ckxl7","stairs":"MeetingStairs_stairs__EW4AI"};